
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 11 18.5"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticStyle:{"line-height":"normal","font-variant-ligatures":"normal","font-variant-position":"normal","font-variant-caps":"normal","font-variant-numeric":"normal","font-variant-alternates":"normal","font-feature-settings":"normal","text-indent":"0","text-align":"start","text-decoration-line":"none","text-decoration-style":"solid","text-decoration-color":"#000","text-transform":"none","text-orientation":"mixed","shape-padding":"0","isolation":"auto","mix-blend-mode":"normal"},attrs:{"fill":"#fff","stroke":"#1bd3f2","stroke-linecap":"square","stroke-width":"1.1","d":"M1.2 1c-1.5 1 .7 1.8 1.3 2.7l5.9 5.9-7.8 7.7c1 1.6 1.8.1 2.7-.7l7-7L1.5.7l-.2.2z","color":"#000","font-family":"sans-serif","font-weight":"400","overflow":"visible","paint-order":"stroke fill markers"}})])
          )
        }
      }
    